export default __webpack_public_path__ + "static/media/Recruitment Funnel.5e6ad785.png";